import CheckLicense from "../views/login/checkLicense.vue";

import Layout from "../views/home/home.vue";

import Mine from "./modules/mine";
import retrievePassword from "../views/login/retrievePassword.vue"

import maintenances from "../views/login/maintenance.vue"

import FindRoute from "./modules/find";

import store from "../store";

let redirectPath = "";
if (store.state.systemType == "jd") {
  redirectPath = "/report";
} else {
  redirectPath = "/find";
}

export const routes = [
  {
    path: "/CheckLicense",
    name: "CheckLicense",
    props: (route) => ({ query: route.query.redirect }),
    query: { redirect: "" },
    component: CheckLicense,
  },
  {
    path: "/login",
    name: "login",
    component: resolve => require(['@/views/login'], resolve)
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: maintenances,
  },
  {
    path: "/RetrievePassword",
    name: "retrievePassword",
    component: retrievePassword,

  },
  {
    path: "/ForgetPassword",
    name: "forgetPassword",
    component: retrievePassword,
  },
  {
    path: "/ChangePassword/:changeCode?",
    name: "changePassword",
    component: retrievePassword,
  },
  {
    path: "/EntranceFromEmail",
    name: "EntranceFromEmail",
    component: retrievePassword,
  },
  {
    path: "/401",
    name: "401",
    component: resolve => require(['@/views/pages/401'], resolve),
  },
  {
    path: "/401",
    name: "401",
    component: resolve => require(['@/views/pages/401'], resolve),
  },
  // {
  //   path: "404",
  //   name: "404",
  //   component: () => import("../views/pages/404.vue"),
  // },
  {
    path: "/",
    name: "home",
    component: Layout,
    redirect: redirectPath,
    children: [

      {
        path: "/customHome",
        name: "customHome",
        component: resolve => require(['@/views/aboutMe/customHome/customHome'], resolve),
        meta: {
          title: "$t-customHome",
          controlField: 'homeMenu'
        },
      },
      {
        path: "find",
        name: "find",
        component: resolve => require(['@/views/find/find'], resolve),
        props: (route) => ({ query: route.query.tab }),
        redirect: "/find",
        query: { tab: "guessYouLike" },
        meta: { controlField: 'findMenu' },
        isShowFind: true,
        children: FindRoute,
      },
      {
        path: "findView/:reportId?",
        name: "findView",
        isShowFind: true,
        meta: { controlField: 'findMenu' },
        component: resolve => require(['@/views/report/reportView'], resolve),
      },
      {
        path: "subview/reportView/:reportId?/:folderId?",
        name: "subview",
        component: resolve => require(['@/views/report/subview'], resolve),
      },
      {
        path: "report",
        name: "report",
        component: resolve => require(['@/views/report'], resolve),
        redirect: "/report",
        meta: { controlField: 'reportMenu' },
        isShowReport: true,
        children: [
          {
            path: "/report/:type?",
            name: "reportList",
            meta: { controlField: 'reportMenu' },
            query: { qid: "", type: 0 },
            component: resolve => require(['@/views/report/reportList'], resolve)
          },
          {
            path: "reportView/:reportId?/:folderId?",
            name: "reportView",
            meta: { controlField: 'reportMenu' },
            component: resolve => require(['@/views/report/reportView'], resolve),
          },
          {
            path: "reportOut/timeOut",
            name: "reportTimeOut",
            meta: { controlField: 'reportMenu' },
            component: (resolve) =>
              require(["../views/report/reportOut"], resolve),
          },
        ]
      },
      {
        path: "reportOut/kickOff",
        name: "kickOff",
        component: (resolve) => require(["../views/report/reportOut"], resolve),
      },
      {
        path: "design",
        name: "design",
        redirect: "/design",
        meta: { controlField: 'desginMenu' },
        component: (resolve) => require(["../views/design/index.vue"], resolve),
        children: [
          {
            path: "",
            name: "designList",
            meta: { controlField: 'desginMenu' },
            component: (resolve) =>
              require(["../views/design/design.vue"], resolve),
          },
          {
            path: "devHub",
            name: "devHub",
            meta: { title: "DevHub", controlField: 'desginMenu' },
            component: (resolve) =>
              require(["../views/design/devHub.vue"], resolve),
          },
          {
            path: "widget",
            name: "widget",
            meta: { title: "$t-PluginDev", controlField: 'desginMenu' },
            component: (resolve) =>
              require(["../views/design/devHub.vue"], resolve),
          },

          {
            path: "designView/:id?/:versionId?",
            name: "designView",
            meta: { title: "$t-pictorial", controlField: 'desginMenu' },
            component: (resolve) =>
              require(["../views/design/designView.vue"], resolve),
          },
          {
            path: "management",
            name: "management",
            meta: { controlField: 'desginMenu' },
            component: (resolve) =>
              require(["../views/design/component/management.vue"], resolve),
          },
        ],
      },
      {
        path: "/about",
        name: "about",
        component: resolve => require(['@/views/aboutMe'], resolve),
        redirect: "/about/view",
        meta: { controlField: 'myMenu' },
        children: Mine,
        isShowMy: true,
      },
      {
        path: "/about/minePage",
        name: "minePage",
        meta: { controlField: 'myMenu' },
        props: (route) => ({
          query: { userId: route.query.id, type: route.query.type },
        }),
        component: resolve => require(['@/views/aboutMe/minePage'], resolve),
        redirect: "/about/minePage/personalPage",
        children: [
          {
            path: "personalPage",
            name: "personalPage",
            meta: { controlField: 'myMenu', noAuth: true },
            props: (route) => ({
              query: { userId: route.query.id, type: route.query.type },
            }),
            component: resolve => require(['@/views/aboutMe/minePage/child/personalPage'], resolve),
            redirect: "/about/minePage/personalPage/list",
            children: [
              {
                path: "list",
                name: "gridList",
                meta: { controlField: 'myMenu' },
                props: (route) => ({
                  query: { userId: route.query.id, type: route.query.type },
                }),
                component: resolve => require(['@/views/aboutMe/minePage/child/reportGridList'], resolve),
              },
            ],
          },
          {
            path: "focusState",
            name: "focusState",
            meta: { controlField: 'myMenu' },
            props: (route) => ({ query: { userId: route.query.id } }),
            component: resolve => require(['@/views/aboutMe/minePage/child/focusState'], resolve),
          },
          {
            path: "personalInfo",
            name: "personalInfo",
            meta: { controlField: 'myMenu' },
            props: (route) => ({ query: { userId: route.query.id } }),
            component: resolve => require(['@/views/aboutMe/minePage/child/personalInfo'], resolve),
          },
          {
            path: "userlist",
            name: "focusFans",
            meta: { controlField: 'myMenu' },
            props: (route) => ({
              query: { userId: route.query.id, type: route.query.type },
            }),
            component: resolve => require(['@/views/aboutMe/minePage/child/focusFans'], resolve)
          },
        ],
      },
      {
        path: "/customPage",
        name: "customPage",
        component: resolve => require(['@/views/aboutMe/customHome'], resolve),
        meta: {
          title: "$t-customHome",
          controlField: 'myMenu'
        },
      },

      {
        path: "/customMenu",
        name: "customMenu",
        meta: { controlField: 'customMenu' },
        component: resolve => require(['@/views/customMenu/customMenu'], resolve),
      },
      {
        path: "/changeWord",
        name: "changeWord",
        meta: {
          title: "修改密码",
        },
        component: resolve => require(['@/views/login/component/innerWordChange'], resolve),
      },
      {
        path: "/bomRedirect",
        name: "transsionMenu0",
        component: resolve => require(['@/views/bomRedirect'], resolve),
      },
      {
        path: "/bomProfitRedirect",
        name: "transsionMenu1",
        component: resolve => require(['@/views/bomRedirect/bomProfitRedirect'], resolve),
      },
      {
        path: "/test",
        name: "test",
        meta: { noAuth: true },
        component: resolve => require(['@/components/test'], resolve),
      },
      {
        path: "404",
        name: "404",
        meta: { noAuth: true },
        component: resolve => require(['@/views/pages/404'], resolve),
      },
      {
        path: "504",
        name: "504",
        meta: { noAuth: true },
        props: (route) => ({ query: route.query.back }),
        component: resolve => require(['@/views/home/timeOut'], resolve),
      },
      {
        path: "qbi/embed",
        name: "qbiEmbedDownloader",
        meta: { controlField: 'reportMenu' },
        component: resolve => require(['@/views/report/component/QuickBIEmbedJSSdk'], resolve),
      }
    ],
  }
];
